import React, { useCallback, useContext, useEffect, useState } from 'react';

import UsersSettingsContext from 'contexts/UsersSettingsContext';

import UsersSidebar from './UsersSidebar';

const UsersSidebarContainer = () => {
  const { users, isLoading } = useContext(UsersSettingsContext);
  const [searchText, setSearchText] = useState<string>('');
  const [filteredUsers, setFilteredUsers] = useState<
    (UserManagement.PendingUser | UserManagement.SignedUpUser)[]
  >([]);

  useEffect(() => {
    if (searchText === '') {
      setFilteredUsers(users);
      return;
    }

    setFilteredUsers(
      users.filter((user) => {
        const searchLower = searchText.toLowerCase();
        const displayNameMatch = (user.displayName ?? '')
          .toLowerCase()
          .includes(searchLower);
        const emailMatch = (user.email ?? '')
          .toLowerCase()
          .includes(searchLower);
        return displayNameMatch || emailMatch;
      }),
    );
  }, [users, searchText]);

  const onSearchTextChanged = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(event.target.value);
    },
    [],
  );

  return (
    <UsersSidebar
      users={filteredUsers}
      isLoading={isLoading}
      searchText={searchText}
      onSearchTextChanged={onSearchTextChanged}
    />
  );
};

export default UsersSidebarContainer;
